const doc = [({"da":({"activerecord":({"attributes":({"number_of_students_csv":({"file":"Fil"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;